import { JOBS_URL } from '@/utils/constants'

const JOBS = () => JOBS_URL
const JOB_BY_ID = (id: string) => `${JOBS_URL}/${id}`
const JOBS_NOTIFICATIONS = () => `${JOBS_URL}/activities`

export default {
  JOBS,
  JOB_BY_ID,
  JOBS_NOTIFICATIONS
}
